import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import { Reporte } from '../model/Reporte';
import { catchError, Observable, throwError } from 'rxjs';
import { NotificationService } from './notification.service';
import { saveFile } from '../helpers/file-download';
import { environment } from '../../environments/environment';


@Injectable()
export class ReportService {
    private url = environment.server + environment.app + environment.api;

    constructor( private http: HttpClient,
                 private notificationService: NotificationService) { }

    downloadFile(pdfName: string, nombre: string, opcion: string, parametros:any) {
        const url = `${this.url}report`;
        let paramsReport = new Reporte(pdfName,nombre,opcion, parametros);
        this.http.post(url , paramsReport, { responseType: 'arraybuffer', observe: 'response' })
            .subscribe( (res:HttpResponse<any>) => {
                if(res.body != null) {
                    saveFile(res.body, nombre, opcion);
                }
        });
    }

    getPDFView(pdfName: string, nombre: string, opcion: string, parametros:any):Observable<any> {
        const url = `${this.url}report`;
        let paramsReport = new Reporte(pdfName,nombre,opcion, parametros);
        return this.http.post(url , paramsReport, { responseType: 'arraybuffer', observe: 'response' });
    }
    
}